// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__1bUJK","messages":"Chat_messages__3gSf-","dateDivider":"Chat_dateDivider__1eDyY"};